import { useMemo as o, createElement as t } from "react";
const d = (l, i) => o(() => {
  if (!l.icon)
    return null;
  const { element: u, children: c, ...n } = l.icon, r = c.map((p, f) => {
    const { element: h, ...e } = p;
    return e["fill-rule"] && (e.fillRule = e["fill-rule"], delete e["fill-rule"]), e["clip-rule"] && (e.clipRule = e["clip-rule"], delete e["clip-rule"]), e["clip-path"] && (e.clipPath = e["clip-path"], delete e["clip-path"]), t(h, { key: f, ...e });
  });
  return i && r.push(t("title", {}, [i])), t(
    u,
    { ...n, "aria-hidden": !0 },
    r
  );
}, [l, i]);
export {
  d as useSvg
};
